import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0c7b7f6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "closer-controller-opened is-hidden-mobile"
}
const _hoisted_2 = { class: "closer-controller-container level" }
const _hoisted_3 = { class: "app-button-container level" }
const _hoisted_4 = {
  key: 1,
  class: "closer-controller-closed level is-hidden-mobile"
}
const _hoisted_5 = {
  key: 2,
  class: "is-hidden-mobile level"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_7 = { class: "mobile-footer level is-mobile is-hidden-desktop" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloserController = _resolveComponent("CloserController")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showAll && !_ctx.isRekion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_CloserController, {
              modelValue: _ctx.showAll,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showAll) = $event)),
              "aria-expanded": _ctx.showAll,
              "aria-controls": "detailed-search-queries",
              text: [_ctx.$t('parts.open'), _ctx.$t('parts.close')],
              "data-cy": "detailed-search-closer-controller-opened"
            }, null, 8, ["modelValue", "aria-expanded", "text"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_AppButton, {
              onClick: _withModifiers(_ctx.clearForm, ["prevent"]),
              onKeydown: _withKeys(_withModifiers(_ctx.clearForm, ["prevent"]), ["space","enter"]),
              type: "reset",
              styled: "is-none",
              class: "has-text-link search-queries-clear-button",
              id: "search-queries-clear-button"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("parts.clear")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "onKeydown"]),
            _createVNode(_component_AppButton, {
              "data-cy": "detailed-search-keyword-sub",
              styled: "is-accent",
              type: "submit",
              "aria-label": _ctx.$t('parts.search')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("parts.search")), 1)
              ]),
              _: 1
            }, 8, ["aria-label"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.showAll && !_ctx.isRekion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_CloserController, {
            modelValue: _ctx.showAll,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showAll) = $event)),
            "aria-expanded": _ctx.showAll,
            "aria-controls": "detailed-search-queries",
            text: [_ctx.$t('parts.open'), _ctx.$t('parts.close')],
            "data-cy": "detailed-search-closer-controller-closed"
          }, null, 8, ["modelValue", "aria-expanded", "text"]),
          _createVNode(_component_AppButton, {
            onClick: _withModifiers(_ctx.clearForm, ["prevent"]),
            onKeydown: _withKeys(_withModifiers(_ctx.clearForm, ["prevent"]), ["space","enter"]),
            type: "reset",
            styled: "is-none",
            class: "has-text-link search-queries-clear-button",
            id: "search-queries-clear-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("parts.clear")), 1)
            ]),
            _: 1
          }, 8, ["onClick", "onKeydown"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isRekion)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(_component_AppButton, {
            onClick: _withModifiers(_ctx.clearForm, ["prevent"]),
            onKeydown: _withKeys(_withModifiers(_ctx.clearForm, ["prevent"]), ["space","enter"]),
            type: "reset",
            styled: "is-none",
            class: "has-text-link search-queries-clear-button",
            id: "search-queries-clear-button"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("parts.clear")), 1)
            ]),
            _: 1
          }, 8, ["onClick", "onKeydown"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_AppButton, {
        onClick: _withModifiers(_ctx.clearForm, ["prevent"]),
        onKeydown: _withKeys(_withModifiers(_ctx.clearForm, ["prevent"]), ["space","enter"]),
        type: "reset",
        styled: "is-none",
        class: _normalizeClass(["has-text-link", { 'center-button': _ctx.isRekion }]),
        id: "search-queries-clear-button-mobile"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("label.clear")), 1)
        ]),
        _: 1
      }, 8, ["onClick", "onKeydown", "class"]),
      (!_ctx.isRekion)
        ? (_openBlock(), _createBlock(_component_AppButton, {
            key: 0,
            "data-cy": "detailed-search-keyword-sub-mobile",
            styled: "is-accent",
            type: "submit",
            "aria-label": _ctx.$t('parts.search')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("parts.search")), 1)
            ]),
            _: 1
          }, 8, ["aria-label"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}